// extracted by mini-css-extract-plugin
module.exports = {"c-link":"link_c-link__VkbRA","c-link_button":"link_c-link_button__Z0q__"};